import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Clock } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import logo from "@/assets/logo-liftco.png";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-primary text-primary-foreground">
      {/* Main Footer */}
      <div className="container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src={logo} 
              alt="LIFTCO - Ανελκυστήρες Θεσσαλονίκη" 
              className="h-16 w-auto mb-4 brightness-0 invert"
              width="337"
              height="64"
              loading="lazy"
            />
            <p className="text-primary-foreground/80 mb-6 leading-relaxed">
              {t("footer.description")}
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=100066378554308"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">{t("footer.quicklinks")}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("nav.about")}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("nav.services")}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("nav.contact")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">{t("footer.services")}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services/installation" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("services.installation")}
                </Link>
              </li>
              <li>
                <Link to="/services/maintenance" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("services.maintenance")}
                </Link>
              </li>
              <li>
                <Link to="/services/modernization" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("services.modernization")}
                </Link>
              </li>
              <li>
                <Link to="/services/escalators" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  {t("services.escalators")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">{t("footer.contact")}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 mt-0.5 text-accent" />
                <span className="text-primary-foreground/80">{t("company.address")}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-accent" />
                <a href="tel:2310270290" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  2310 270290
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-accent" />
                <a href="tel:6947127721" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  694 7127721
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-accent" />
                <a href="mailto:liftco.thessaloniki@gmail.com" className="text-primary-foreground/80 hover:text-accent transition-colors text-sm">
                  liftco.thessaloniki@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="h-5 w-5 text-accent" />
                <span className="text-primary-foreground/80">{t("footer.24h")}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-foreground/10">
        <div className="container py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-primary-foreground/80 text-sm">
            © {new Date().getFullYear()} LIFTCO E.E. {t("footer.rights")}
          </p>
          <p className="text-primary-foreground/80 text-sm">
            {t("footer.serving")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
